import React, { useEffect } from 'react';
import { Spinner } from '../../../../common';
import {
  useGetNewsCategoryDetailQuery,
  useSaveNewsCategoryMutation,
} from '../../../../../redux/services/news';
import { routes } from '../../../../../utils/helpers/ApiClient';
import NewsCategoryForm from './NewsCategoryForm.jsx';
import { AppBarCMS } from '../../../../basic';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import { useToastMessages } from '../../../../../hooks/useToastMessages';

const NewsCategoriesEdit = ({ mode }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { saveSuccess: showSaveSuccess } = useToastMessages();

  const isCreate = mode === 'create';
  const isEdit = mode === 'edit';

  useEffect(() => {
    document.title = isEdit
      ? t('Úprava kategórie aktualít') + ' - FRI CMS'
      : t('Pridanie kategórie aktualít') + ' - FRI CMS';
  }, []); // Runs on mount

  const { data: newsCategoryDetail, isLoading } = useGetNewsCategoryDetailQuery(
    id,
    { skip: !isEdit },
  );

  const [saveNewsCategory, { isSuccess: isSaveSuccess }] =
    useSaveNewsCategoryMutation();

  useEffect(() => {
    if (isSaveSuccess) {
      showSaveSuccess();
      navigate(routes.cmsNewsCategories);
    }
  }, [isSaveSuccess]);

  const title = isCreate
    ? t('Pridanie kategórie aktualít')
    : t('Úprava kategórie aktualít');

  const initials = {
    name: undefined,
    description: undefined,
    ...newsCategoryDetail,
  };

  return isEdit && isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={title}
        backUrl={routes.cmsNewsCategories}
        backUrlTooltip={t('Kategórie aktualít')}
        permissionsBasic={'news-categories'}
      />
      <div style={{ margin: '10px' }}>
        <NewsCategoryForm
          initials={initials}
          handleSubmit={(values) => {
            saveNewsCategory({ data: values, id });
          }}
        />
      </div>
    </>
  );
};

export default NewsCategoriesEdit;
